export var BaseOrderByInput;
(function (BaseOrderByInput) {
    BaseOrderByInput["CurrentOwnerAsc"] = "currentOwner_ASC";
    BaseOrderByInput["CurrentOwnerDesc"] = "currentOwner_DESC";
    BaseOrderByInput["IdAsc"] = "id_ASC";
    BaseOrderByInput["IdDesc"] = "id_DESC";
    BaseOrderByInput["IssuerAsc"] = "issuer_ASC";
    BaseOrderByInput["IssuerDesc"] = "issuer_DESC";
    BaseOrderByInput["MetaAnimationUrlAsc"] = "meta_animationUrl_ASC";
    BaseOrderByInput["MetaAnimationUrlDesc"] = "meta_animationUrl_DESC";
    BaseOrderByInput["MetaDescriptionAsc"] = "meta_description_ASC";
    BaseOrderByInput["MetaDescriptionDesc"] = "meta_description_DESC";
    BaseOrderByInput["MetaIdAsc"] = "meta_id_ASC";
    BaseOrderByInput["MetaIdDesc"] = "meta_id_DESC";
    BaseOrderByInput["MetaImageAsc"] = "meta_image_ASC";
    BaseOrderByInput["MetaImageDesc"] = "meta_image_DESC";
    BaseOrderByInput["MetaNameAsc"] = "meta_name_ASC";
    BaseOrderByInput["MetaNameDesc"] = "meta_name_DESC";
    BaseOrderByInput["MetaTypeAsc"] = "meta_type_ASC";
    BaseOrderByInput["MetaTypeDesc"] = "meta_type_DESC";
    BaseOrderByInput["MetadataAsc"] = "metadata_ASC";
    BaseOrderByInput["MetadataDesc"] = "metadata_DESC";
    BaseOrderByInput["SymbolAsc"] = "symbol_ASC";
    BaseOrderByInput["SymbolDesc"] = "symbol_DESC";
    BaseOrderByInput["TypeAsc"] = "type_ASC";
    BaseOrderByInput["TypeDesc"] = "type_DESC";
})(BaseOrderByInput || (BaseOrderByInput = {}));
export var BaseType;
(function (BaseType) {
    BaseType["Audio"] = "audio";
    BaseType["Mixed"] = "mixed";
    BaseType["Png"] = "png";
    BaseType["Svg"] = "svg";
    BaseType["Video"] = "video";
})(BaseType || (BaseType = {}));
export var CacheStatusOrderByInput;
(function (CacheStatusOrderByInput) {
    CacheStatusOrderByInput["IdAsc"] = "id_ASC";
    CacheStatusOrderByInput["IdDesc"] = "id_DESC";
    CacheStatusOrderByInput["LastBlockTimestampAsc"] = "lastBlockTimestamp_ASC";
    CacheStatusOrderByInput["LastBlockTimestampDesc"] = "lastBlockTimestamp_DESC";
})(CacheStatusOrderByInput || (CacheStatusOrderByInput = {}));
export var CollectionEntityOrderByInput;
(function (CollectionEntityOrderByInput) {
    CollectionEntityOrderByInput["BlockNumberAsc"] = "blockNumber_ASC";
    CollectionEntityOrderByInput["BlockNumberDesc"] = "blockNumber_DESC";
    CollectionEntityOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CollectionEntityOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CollectionEntityOrderByInput["CurrentOwnerAsc"] = "currentOwner_ASC";
    CollectionEntityOrderByInput["CurrentOwnerDesc"] = "currentOwner_DESC";
    CollectionEntityOrderByInput["HashAsc"] = "hash_ASC";
    CollectionEntityOrderByInput["HashDesc"] = "hash_DESC";
    CollectionEntityOrderByInput["IdAsc"] = "id_ASC";
    CollectionEntityOrderByInput["IdDesc"] = "id_DESC";
    CollectionEntityOrderByInput["ImageAsc"] = "image_ASC";
    CollectionEntityOrderByInput["ImageDesc"] = "image_DESC";
    CollectionEntityOrderByInput["IssuerAsc"] = "issuer_ASC";
    CollectionEntityOrderByInput["IssuerDesc"] = "issuer_DESC";
    CollectionEntityOrderByInput["MaxAsc"] = "max_ASC";
    CollectionEntityOrderByInput["MaxDesc"] = "max_DESC";
    CollectionEntityOrderByInput["MediaAsc"] = "media_ASC";
    CollectionEntityOrderByInput["MediaDesc"] = "media_DESC";
    CollectionEntityOrderByInput["MetaAnimationUrlAsc"] = "meta_animationUrl_ASC";
    CollectionEntityOrderByInput["MetaAnimationUrlDesc"] = "meta_animationUrl_DESC";
    CollectionEntityOrderByInput["MetaDescriptionAsc"] = "meta_description_ASC";
    CollectionEntityOrderByInput["MetaDescriptionDesc"] = "meta_description_DESC";
    CollectionEntityOrderByInput["MetaIdAsc"] = "meta_id_ASC";
    CollectionEntityOrderByInput["MetaIdDesc"] = "meta_id_DESC";
    CollectionEntityOrderByInput["MetaImageAsc"] = "meta_image_ASC";
    CollectionEntityOrderByInput["MetaImageDesc"] = "meta_image_DESC";
    CollectionEntityOrderByInput["MetaNameAsc"] = "meta_name_ASC";
    CollectionEntityOrderByInput["MetaNameDesc"] = "meta_name_DESC";
    CollectionEntityOrderByInput["MetaTypeAsc"] = "meta_type_ASC";
    CollectionEntityOrderByInput["MetaTypeDesc"] = "meta_type_DESC";
    CollectionEntityOrderByInput["MetadataAsc"] = "metadata_ASC";
    CollectionEntityOrderByInput["MetadataDesc"] = "metadata_DESC";
    CollectionEntityOrderByInput["NameAsc"] = "name_ASC";
    CollectionEntityOrderByInput["NameDesc"] = "name_DESC";
    CollectionEntityOrderByInput["NftCountAsc"] = "nftCount_ASC";
    CollectionEntityOrderByInput["NftCountDesc"] = "nftCount_DESC";
    CollectionEntityOrderByInput["SupplyAsc"] = "supply_ASC";
    CollectionEntityOrderByInput["SupplyDesc"] = "supply_DESC";
    CollectionEntityOrderByInput["SymbolAsc"] = "symbol_ASC";
    CollectionEntityOrderByInput["SymbolDesc"] = "symbol_DESC";
    CollectionEntityOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CollectionEntityOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    CollectionEntityOrderByInput["VersionAsc"] = "version_ASC";
    CollectionEntityOrderByInput["VersionDesc"] = "version_DESC";
})(CollectionEntityOrderByInput || (CollectionEntityOrderByInput = {}));
export var CollectorOrderByInput;
(function (CollectorOrderByInput) {
    CollectorOrderByInput["AverageAsc"] = "average_ASC";
    CollectorOrderByInput["AverageDesc"] = "average_DESC";
    CollectorOrderByInput["CollectionsAsc"] = "collections_ASC";
    CollectorOrderByInput["CollectionsDesc"] = "collections_DESC";
    CollectorOrderByInput["IdAsc"] = "id_ASC";
    CollectorOrderByInput["IdDesc"] = "id_DESC";
    CollectorOrderByInput["MaxAsc"] = "max_ASC";
    CollectorOrderByInput["MaxDesc"] = "max_DESC";
    CollectorOrderByInput["NameAsc"] = "name_ASC";
    CollectorOrderByInput["NameDesc"] = "name_DESC";
    CollectorOrderByInput["TotalAsc"] = "total_ASC";
    CollectorOrderByInput["TotalDesc"] = "total_DESC";
    CollectorOrderByInput["UniqueCollectorsAsc"] = "uniqueCollectors_ASC";
    CollectorOrderByInput["UniqueCollectorsDesc"] = "uniqueCollectors_DESC";
    CollectorOrderByInput["UniqueAsc"] = "unique_ASC";
    CollectorOrderByInput["UniqueDesc"] = "unique_DESC";
    CollectorOrderByInput["VolumeAsc"] = "volume_ASC";
    CollectorOrderByInput["VolumeDesc"] = "volume_DESC";
})(CollectorOrderByInput || (CollectorOrderByInput = {}));
export var EmoteOrderByInput;
(function (EmoteOrderByInput) {
    EmoteOrderByInput["CallerAsc"] = "caller_ASC";
    EmoteOrderByInput["CallerDesc"] = "caller_DESC";
    EmoteOrderByInput["IdAsc"] = "id_ASC";
    EmoteOrderByInput["IdDesc"] = "id_DESC";
    EmoteOrderByInput["NftBlockNumberAsc"] = "nft_blockNumber_ASC";
    EmoteOrderByInput["NftBlockNumberDesc"] = "nft_blockNumber_DESC";
    EmoteOrderByInput["NftBurnedAsc"] = "nft_burned_ASC";
    EmoteOrderByInput["NftBurnedDesc"] = "nft_burned_DESC";
    EmoteOrderByInput["NftCreatedAtAsc"] = "nft_createdAt_ASC";
    EmoteOrderByInput["NftCreatedAtDesc"] = "nft_createdAt_DESC";
    EmoteOrderByInput["NftCurrentOwnerAsc"] = "nft_currentOwner_ASC";
    EmoteOrderByInput["NftCurrentOwnerDesc"] = "nft_currentOwner_DESC";
    EmoteOrderByInput["NftEmoteCountAsc"] = "nft_emoteCount_ASC";
    EmoteOrderByInput["NftEmoteCountDesc"] = "nft_emoteCount_DESC";
    EmoteOrderByInput["NftHashAsc"] = "nft_hash_ASC";
    EmoteOrderByInput["NftHashDesc"] = "nft_hash_DESC";
    EmoteOrderByInput["NftIdAsc"] = "nft_id_ASC";
    EmoteOrderByInput["NftIdDesc"] = "nft_id_DESC";
    EmoteOrderByInput["NftImageAsc"] = "nft_image_ASC";
    EmoteOrderByInput["NftImageDesc"] = "nft_image_DESC";
    EmoteOrderByInput["NftInstanceAsc"] = "nft_instance_ASC";
    EmoteOrderByInput["NftInstanceDesc"] = "nft_instance_DESC";
    EmoteOrderByInput["NftIssuerAsc"] = "nft_issuer_ASC";
    EmoteOrderByInput["NftIssuerDesc"] = "nft_issuer_DESC";
    EmoteOrderByInput["NftMediaAsc"] = "nft_media_ASC";
    EmoteOrderByInput["NftMediaDesc"] = "nft_media_DESC";
    EmoteOrderByInput["NftMetadataAsc"] = "nft_metadata_ASC";
    EmoteOrderByInput["NftMetadataDesc"] = "nft_metadata_DESC";
    EmoteOrderByInput["NftNameAsc"] = "nft_name_ASC";
    EmoteOrderByInput["NftNameDesc"] = "nft_name_DESC";
    EmoteOrderByInput["NftPendingAsc"] = "nft_pending_ASC";
    EmoteOrderByInput["NftPendingDesc"] = "nft_pending_DESC";
    EmoteOrderByInput["NftPriceAsc"] = "nft_price_ASC";
    EmoteOrderByInput["NftPriceDesc"] = "nft_price_DESC";
    EmoteOrderByInput["NftRecipientAsc"] = "nft_recipient_ASC";
    EmoteOrderByInput["NftRecipientDesc"] = "nft_recipient_DESC";
    EmoteOrderByInput["NftRoyaltyAsc"] = "nft_royalty_ASC";
    EmoteOrderByInput["NftRoyaltyDesc"] = "nft_royalty_DESC";
    EmoteOrderByInput["NftSnAsc"] = "nft_sn_ASC";
    EmoteOrderByInput["NftSnDesc"] = "nft_sn_DESC";
    EmoteOrderByInput["NftTransferableAsc"] = "nft_transferable_ASC";
    EmoteOrderByInput["NftTransferableDesc"] = "nft_transferable_DESC";
    EmoteOrderByInput["NftUpdatedAtAsc"] = "nft_updatedAt_ASC";
    EmoteOrderByInput["NftUpdatedAtDesc"] = "nft_updatedAt_DESC";
    EmoteOrderByInput["NftVersionAsc"] = "nft_version_ASC";
    EmoteOrderByInput["NftVersionDesc"] = "nft_version_DESC";
    EmoteOrderByInput["ValueAsc"] = "value_ASC";
    EmoteOrderByInput["ValueDesc"] = "value_DESC";
    EmoteOrderByInput["VersionAsc"] = "version_ASC";
    EmoteOrderByInput["VersionDesc"] = "version_DESC";
})(EmoteOrderByInput || (EmoteOrderByInput = {}));
export var EventOrderByInput;
(function (EventOrderByInput) {
    EventOrderByInput["BlockNumberAsc"] = "blockNumber_ASC";
    EventOrderByInput["BlockNumberDesc"] = "blockNumber_DESC";
    EventOrderByInput["CallerAsc"] = "caller_ASC";
    EventOrderByInput["CallerDesc"] = "caller_DESC";
    EventOrderByInput["CurrentOwnerAsc"] = "currentOwner_ASC";
    EventOrderByInput["CurrentOwnerDesc"] = "currentOwner_DESC";
    EventOrderByInput["IdAsc"] = "id_ASC";
    EventOrderByInput["IdDesc"] = "id_DESC";
    EventOrderByInput["InteractionAsc"] = "interaction_ASC";
    EventOrderByInput["InteractionDesc"] = "interaction_DESC";
    EventOrderByInput["MetaAsc"] = "meta_ASC";
    EventOrderByInput["MetaDesc"] = "meta_DESC";
    EventOrderByInput["NftBlockNumberAsc"] = "nft_blockNumber_ASC";
    EventOrderByInput["NftBlockNumberDesc"] = "nft_blockNumber_DESC";
    EventOrderByInput["NftBurnedAsc"] = "nft_burned_ASC";
    EventOrderByInput["NftBurnedDesc"] = "nft_burned_DESC";
    EventOrderByInput["NftCreatedAtAsc"] = "nft_createdAt_ASC";
    EventOrderByInput["NftCreatedAtDesc"] = "nft_createdAt_DESC";
    EventOrderByInput["NftCurrentOwnerAsc"] = "nft_currentOwner_ASC";
    EventOrderByInput["NftCurrentOwnerDesc"] = "nft_currentOwner_DESC";
    EventOrderByInput["NftEmoteCountAsc"] = "nft_emoteCount_ASC";
    EventOrderByInput["NftEmoteCountDesc"] = "nft_emoteCount_DESC";
    EventOrderByInput["NftHashAsc"] = "nft_hash_ASC";
    EventOrderByInput["NftHashDesc"] = "nft_hash_DESC";
    EventOrderByInput["NftIdAsc"] = "nft_id_ASC";
    EventOrderByInput["NftIdDesc"] = "nft_id_DESC";
    EventOrderByInput["NftImageAsc"] = "nft_image_ASC";
    EventOrderByInput["NftImageDesc"] = "nft_image_DESC";
    EventOrderByInput["NftInstanceAsc"] = "nft_instance_ASC";
    EventOrderByInput["NftInstanceDesc"] = "nft_instance_DESC";
    EventOrderByInput["NftIssuerAsc"] = "nft_issuer_ASC";
    EventOrderByInput["NftIssuerDesc"] = "nft_issuer_DESC";
    EventOrderByInput["NftMediaAsc"] = "nft_media_ASC";
    EventOrderByInput["NftMediaDesc"] = "nft_media_DESC";
    EventOrderByInput["NftMetadataAsc"] = "nft_metadata_ASC";
    EventOrderByInput["NftMetadataDesc"] = "nft_metadata_DESC";
    EventOrderByInput["NftNameAsc"] = "nft_name_ASC";
    EventOrderByInput["NftNameDesc"] = "nft_name_DESC";
    EventOrderByInput["NftPendingAsc"] = "nft_pending_ASC";
    EventOrderByInput["NftPendingDesc"] = "nft_pending_DESC";
    EventOrderByInput["NftPriceAsc"] = "nft_price_ASC";
    EventOrderByInput["NftPriceDesc"] = "nft_price_DESC";
    EventOrderByInput["NftRecipientAsc"] = "nft_recipient_ASC";
    EventOrderByInput["NftRecipientDesc"] = "nft_recipient_DESC";
    EventOrderByInput["NftRoyaltyAsc"] = "nft_royalty_ASC";
    EventOrderByInput["NftRoyaltyDesc"] = "nft_royalty_DESC";
    EventOrderByInput["NftSnAsc"] = "nft_sn_ASC";
    EventOrderByInput["NftSnDesc"] = "nft_sn_DESC";
    EventOrderByInput["NftTransferableAsc"] = "nft_transferable_ASC";
    EventOrderByInput["NftTransferableDesc"] = "nft_transferable_DESC";
    EventOrderByInput["NftUpdatedAtAsc"] = "nft_updatedAt_ASC";
    EventOrderByInput["NftUpdatedAtDesc"] = "nft_updatedAt_DESC";
    EventOrderByInput["NftVersionAsc"] = "nft_version_ASC";
    EventOrderByInput["NftVersionDesc"] = "nft_version_DESC";
    EventOrderByInput["TimestampAsc"] = "timestamp_ASC";
    EventOrderByInput["TimestampDesc"] = "timestamp_DESC";
    EventOrderByInput["VersionAsc"] = "version_ASC";
    EventOrderByInput["VersionDesc"] = "version_DESC";
})(EventOrderByInput || (EventOrderByInput = {}));
export var Interaction;
(function (Interaction) {
    Interaction["Accept"] = "ACCEPT";
    Interaction["Base"] = "BASE";
    Interaction["Burn"] = "BURN";
    Interaction["Buy"] = "BUY";
    Interaction["Changeissuer"] = "CHANGEISSUER";
    Interaction["Create"] = "CREATE";
    Interaction["Destroy"] = "DESTROY";
    Interaction["Emote"] = "EMOTE";
    Interaction["Equip"] = "EQUIP";
    Interaction["Equippable"] = "EQUIPPABLE";
    Interaction["List"] = "LIST";
    Interaction["Lock"] = "LOCK";
    Interaction["Mint"] = "MINT";
    Interaction["PayRoyalty"] = "PAY_ROYALTY";
    Interaction["Resadd"] = "RESADD";
    Interaction["Royalty"] = "ROYALTY";
    Interaction["Send"] = "SEND";
    Interaction["Setpriority"] = "SETPRIORITY";
    Interaction["Setproperty"] = "SETPROPERTY";
    Interaction["Themeadd"] = "THEMEADD";
    Interaction["Unlist"] = "UNLIST";
})(Interaction || (Interaction = {}));
export var MetadataEntityOrderByInput;
(function (MetadataEntityOrderByInput) {
    MetadataEntityOrderByInput["AnimationUrlAsc"] = "animationUrl_ASC";
    MetadataEntityOrderByInput["AnimationUrlDesc"] = "animationUrl_DESC";
    MetadataEntityOrderByInput["DescriptionAsc"] = "description_ASC";
    MetadataEntityOrderByInput["DescriptionDesc"] = "description_DESC";
    MetadataEntityOrderByInput["IdAsc"] = "id_ASC";
    MetadataEntityOrderByInput["IdDesc"] = "id_DESC";
    MetadataEntityOrderByInput["ImageAsc"] = "image_ASC";
    MetadataEntityOrderByInput["ImageDesc"] = "image_DESC";
    MetadataEntityOrderByInput["NameAsc"] = "name_ASC";
    MetadataEntityOrderByInput["NameDesc"] = "name_DESC";
    MetadataEntityOrderByInput["TypeAsc"] = "type_ASC";
    MetadataEntityOrderByInput["TypeDesc"] = "type_DESC";
})(MetadataEntityOrderByInput || (MetadataEntityOrderByInput = {}));
export var NftEntityOrderByInput;
(function (NftEntityOrderByInput) {
    NftEntityOrderByInput["BlockNumberAsc"] = "blockNumber_ASC";
    NftEntityOrderByInput["BlockNumberDesc"] = "blockNumber_DESC";
    NftEntityOrderByInput["BurnedAsc"] = "burned_ASC";
    NftEntityOrderByInput["BurnedDesc"] = "burned_DESC";
    NftEntityOrderByInput["CollectionBlockNumberAsc"] = "collection_blockNumber_ASC";
    NftEntityOrderByInput["CollectionBlockNumberDesc"] = "collection_blockNumber_DESC";
    NftEntityOrderByInput["CollectionCreatedAtAsc"] = "collection_createdAt_ASC";
    NftEntityOrderByInput["CollectionCreatedAtDesc"] = "collection_createdAt_DESC";
    NftEntityOrderByInput["CollectionCurrentOwnerAsc"] = "collection_currentOwner_ASC";
    NftEntityOrderByInput["CollectionCurrentOwnerDesc"] = "collection_currentOwner_DESC";
    NftEntityOrderByInput["CollectionHashAsc"] = "collection_hash_ASC";
    NftEntityOrderByInput["CollectionHashDesc"] = "collection_hash_DESC";
    NftEntityOrderByInput["CollectionIdAsc"] = "collection_id_ASC";
    NftEntityOrderByInput["CollectionIdDesc"] = "collection_id_DESC";
    NftEntityOrderByInput["CollectionImageAsc"] = "collection_image_ASC";
    NftEntityOrderByInput["CollectionImageDesc"] = "collection_image_DESC";
    NftEntityOrderByInput["CollectionIssuerAsc"] = "collection_issuer_ASC";
    NftEntityOrderByInput["CollectionIssuerDesc"] = "collection_issuer_DESC";
    NftEntityOrderByInput["CollectionMaxAsc"] = "collection_max_ASC";
    NftEntityOrderByInput["CollectionMaxDesc"] = "collection_max_DESC";
    NftEntityOrderByInput["CollectionMediaAsc"] = "collection_media_ASC";
    NftEntityOrderByInput["CollectionMediaDesc"] = "collection_media_DESC";
    NftEntityOrderByInput["CollectionMetadataAsc"] = "collection_metadata_ASC";
    NftEntityOrderByInput["CollectionMetadataDesc"] = "collection_metadata_DESC";
    NftEntityOrderByInput["CollectionNameAsc"] = "collection_name_ASC";
    NftEntityOrderByInput["CollectionNameDesc"] = "collection_name_DESC";
    NftEntityOrderByInput["CollectionNftCountAsc"] = "collection_nftCount_ASC";
    NftEntityOrderByInput["CollectionNftCountDesc"] = "collection_nftCount_DESC";
    NftEntityOrderByInput["CollectionSupplyAsc"] = "collection_supply_ASC";
    NftEntityOrderByInput["CollectionSupplyDesc"] = "collection_supply_DESC";
    NftEntityOrderByInput["CollectionSymbolAsc"] = "collection_symbol_ASC";
    NftEntityOrderByInput["CollectionSymbolDesc"] = "collection_symbol_DESC";
    NftEntityOrderByInput["CollectionUpdatedAtAsc"] = "collection_updatedAt_ASC";
    NftEntityOrderByInput["CollectionUpdatedAtDesc"] = "collection_updatedAt_DESC";
    NftEntityOrderByInput["CollectionVersionAsc"] = "collection_version_ASC";
    NftEntityOrderByInput["CollectionVersionDesc"] = "collection_version_DESC";
    NftEntityOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    NftEntityOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    NftEntityOrderByInput["CurrentOwnerAsc"] = "currentOwner_ASC";
    NftEntityOrderByInput["CurrentOwnerDesc"] = "currentOwner_DESC";
    NftEntityOrderByInput["EmoteCountAsc"] = "emoteCount_ASC";
    NftEntityOrderByInput["EmoteCountDesc"] = "emoteCount_DESC";
    NftEntityOrderByInput["HashAsc"] = "hash_ASC";
    NftEntityOrderByInput["HashDesc"] = "hash_DESC";
    NftEntityOrderByInput["IdAsc"] = "id_ASC";
    NftEntityOrderByInput["IdDesc"] = "id_DESC";
    NftEntityOrderByInput["ImageAsc"] = "image_ASC";
    NftEntityOrderByInput["ImageDesc"] = "image_DESC";
    NftEntityOrderByInput["InstanceAsc"] = "instance_ASC";
    NftEntityOrderByInput["InstanceDesc"] = "instance_DESC";
    NftEntityOrderByInput["IssuerAsc"] = "issuer_ASC";
    NftEntityOrderByInput["IssuerDesc"] = "issuer_DESC";
    NftEntityOrderByInput["MediaAsc"] = "media_ASC";
    NftEntityOrderByInput["MediaDesc"] = "media_DESC";
    NftEntityOrderByInput["MetaAnimationUrlAsc"] = "meta_animationUrl_ASC";
    NftEntityOrderByInput["MetaAnimationUrlDesc"] = "meta_animationUrl_DESC";
    NftEntityOrderByInput["MetaDescriptionAsc"] = "meta_description_ASC";
    NftEntityOrderByInput["MetaDescriptionDesc"] = "meta_description_DESC";
    NftEntityOrderByInput["MetaIdAsc"] = "meta_id_ASC";
    NftEntityOrderByInput["MetaIdDesc"] = "meta_id_DESC";
    NftEntityOrderByInput["MetaImageAsc"] = "meta_image_ASC";
    NftEntityOrderByInput["MetaImageDesc"] = "meta_image_DESC";
    NftEntityOrderByInput["MetaNameAsc"] = "meta_name_ASC";
    NftEntityOrderByInput["MetaNameDesc"] = "meta_name_DESC";
    NftEntityOrderByInput["MetaTypeAsc"] = "meta_type_ASC";
    NftEntityOrderByInput["MetaTypeDesc"] = "meta_type_DESC";
    NftEntityOrderByInput["MetadataAsc"] = "metadata_ASC";
    NftEntityOrderByInput["MetadataDesc"] = "metadata_DESC";
    NftEntityOrderByInput["NameAsc"] = "name_ASC";
    NftEntityOrderByInput["NameDesc"] = "name_DESC";
    NftEntityOrderByInput["ParentBlockNumberAsc"] = "parent_blockNumber_ASC";
    NftEntityOrderByInput["ParentBlockNumberDesc"] = "parent_blockNumber_DESC";
    NftEntityOrderByInput["ParentBurnedAsc"] = "parent_burned_ASC";
    NftEntityOrderByInput["ParentBurnedDesc"] = "parent_burned_DESC";
    NftEntityOrderByInput["ParentCreatedAtAsc"] = "parent_createdAt_ASC";
    NftEntityOrderByInput["ParentCreatedAtDesc"] = "parent_createdAt_DESC";
    NftEntityOrderByInput["ParentCurrentOwnerAsc"] = "parent_currentOwner_ASC";
    NftEntityOrderByInput["ParentCurrentOwnerDesc"] = "parent_currentOwner_DESC";
    NftEntityOrderByInput["ParentEmoteCountAsc"] = "parent_emoteCount_ASC";
    NftEntityOrderByInput["ParentEmoteCountDesc"] = "parent_emoteCount_DESC";
    NftEntityOrderByInput["ParentHashAsc"] = "parent_hash_ASC";
    NftEntityOrderByInput["ParentHashDesc"] = "parent_hash_DESC";
    NftEntityOrderByInput["ParentIdAsc"] = "parent_id_ASC";
    NftEntityOrderByInput["ParentIdDesc"] = "parent_id_DESC";
    NftEntityOrderByInput["ParentImageAsc"] = "parent_image_ASC";
    NftEntityOrderByInput["ParentImageDesc"] = "parent_image_DESC";
    NftEntityOrderByInput["ParentInstanceAsc"] = "parent_instance_ASC";
    NftEntityOrderByInput["ParentInstanceDesc"] = "parent_instance_DESC";
    NftEntityOrderByInput["ParentIssuerAsc"] = "parent_issuer_ASC";
    NftEntityOrderByInput["ParentIssuerDesc"] = "parent_issuer_DESC";
    NftEntityOrderByInput["ParentMediaAsc"] = "parent_media_ASC";
    NftEntityOrderByInput["ParentMediaDesc"] = "parent_media_DESC";
    NftEntityOrderByInput["ParentMetadataAsc"] = "parent_metadata_ASC";
    NftEntityOrderByInput["ParentMetadataDesc"] = "parent_metadata_DESC";
    NftEntityOrderByInput["ParentNameAsc"] = "parent_name_ASC";
    NftEntityOrderByInput["ParentNameDesc"] = "parent_name_DESC";
    NftEntityOrderByInput["ParentPendingAsc"] = "parent_pending_ASC";
    NftEntityOrderByInput["ParentPendingDesc"] = "parent_pending_DESC";
    NftEntityOrderByInput["ParentPriceAsc"] = "parent_price_ASC";
    NftEntityOrderByInput["ParentPriceDesc"] = "parent_price_DESC";
    NftEntityOrderByInput["ParentRecipientAsc"] = "parent_recipient_ASC";
    NftEntityOrderByInput["ParentRecipientDesc"] = "parent_recipient_DESC";
    NftEntityOrderByInput["ParentRoyaltyAsc"] = "parent_royalty_ASC";
    NftEntityOrderByInput["ParentRoyaltyDesc"] = "parent_royalty_DESC";
    NftEntityOrderByInput["ParentSnAsc"] = "parent_sn_ASC";
    NftEntityOrderByInput["ParentSnDesc"] = "parent_sn_DESC";
    NftEntityOrderByInput["ParentTransferableAsc"] = "parent_transferable_ASC";
    NftEntityOrderByInput["ParentTransferableDesc"] = "parent_transferable_DESC";
    NftEntityOrderByInput["ParentUpdatedAtAsc"] = "parent_updatedAt_ASC";
    NftEntityOrderByInput["ParentUpdatedAtDesc"] = "parent_updatedAt_DESC";
    NftEntityOrderByInput["ParentVersionAsc"] = "parent_version_ASC";
    NftEntityOrderByInput["ParentVersionDesc"] = "parent_version_DESC";
    NftEntityOrderByInput["PendingAsc"] = "pending_ASC";
    NftEntityOrderByInput["PendingDesc"] = "pending_DESC";
    NftEntityOrderByInput["PriceAsc"] = "price_ASC";
    NftEntityOrderByInput["PriceDesc"] = "price_DESC";
    NftEntityOrderByInput["RecipientAsc"] = "recipient_ASC";
    NftEntityOrderByInput["RecipientDesc"] = "recipient_DESC";
    NftEntityOrderByInput["RoyaltyAsc"] = "royalty_ASC";
    NftEntityOrderByInput["RoyaltyDesc"] = "royalty_DESC";
    NftEntityOrderByInput["SnAsc"] = "sn_ASC";
    NftEntityOrderByInput["SnDesc"] = "sn_DESC";
    NftEntityOrderByInput["TransferableAsc"] = "transferable_ASC";
    NftEntityOrderByInput["TransferableDesc"] = "transferable_DESC";
    NftEntityOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    NftEntityOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    NftEntityOrderByInput["VersionAsc"] = "version_ASC";
    NftEntityOrderByInput["VersionDesc"] = "version_DESC";
})(NftEntityOrderByInput || (NftEntityOrderByInput = {}));
export var ResourceOrderByInput;
(function (ResourceOrderByInput) {
    ResourceOrderByInput["IdAsc"] = "id_ASC";
    ResourceOrderByInput["IdDesc"] = "id_DESC";
    ResourceOrderByInput["MetaAnimationUrlAsc"] = "meta_animationUrl_ASC";
    ResourceOrderByInput["MetaAnimationUrlDesc"] = "meta_animationUrl_DESC";
    ResourceOrderByInput["MetaDescriptionAsc"] = "meta_description_ASC";
    ResourceOrderByInput["MetaDescriptionDesc"] = "meta_description_DESC";
    ResourceOrderByInput["MetaIdAsc"] = "meta_id_ASC";
    ResourceOrderByInput["MetaIdDesc"] = "meta_id_DESC";
    ResourceOrderByInput["MetaImageAsc"] = "meta_image_ASC";
    ResourceOrderByInput["MetaImageDesc"] = "meta_image_DESC";
    ResourceOrderByInput["MetaNameAsc"] = "meta_name_ASC";
    ResourceOrderByInput["MetaNameDesc"] = "meta_name_DESC";
    ResourceOrderByInput["MetaTypeAsc"] = "meta_type_ASC";
    ResourceOrderByInput["MetaTypeDesc"] = "meta_type_DESC";
    ResourceOrderByInput["MetadataAsc"] = "metadata_ASC";
    ResourceOrderByInput["MetadataDesc"] = "metadata_DESC";
    ResourceOrderByInput["NftBlockNumberAsc"] = "nft_blockNumber_ASC";
    ResourceOrderByInput["NftBlockNumberDesc"] = "nft_blockNumber_DESC";
    ResourceOrderByInput["NftBurnedAsc"] = "nft_burned_ASC";
    ResourceOrderByInput["NftBurnedDesc"] = "nft_burned_DESC";
    ResourceOrderByInput["NftCreatedAtAsc"] = "nft_createdAt_ASC";
    ResourceOrderByInput["NftCreatedAtDesc"] = "nft_createdAt_DESC";
    ResourceOrderByInput["NftCurrentOwnerAsc"] = "nft_currentOwner_ASC";
    ResourceOrderByInput["NftCurrentOwnerDesc"] = "nft_currentOwner_DESC";
    ResourceOrderByInput["NftEmoteCountAsc"] = "nft_emoteCount_ASC";
    ResourceOrderByInput["NftEmoteCountDesc"] = "nft_emoteCount_DESC";
    ResourceOrderByInput["NftHashAsc"] = "nft_hash_ASC";
    ResourceOrderByInput["NftHashDesc"] = "nft_hash_DESC";
    ResourceOrderByInput["NftIdAsc"] = "nft_id_ASC";
    ResourceOrderByInput["NftIdDesc"] = "nft_id_DESC";
    ResourceOrderByInput["NftImageAsc"] = "nft_image_ASC";
    ResourceOrderByInput["NftImageDesc"] = "nft_image_DESC";
    ResourceOrderByInput["NftInstanceAsc"] = "nft_instance_ASC";
    ResourceOrderByInput["NftInstanceDesc"] = "nft_instance_DESC";
    ResourceOrderByInput["NftIssuerAsc"] = "nft_issuer_ASC";
    ResourceOrderByInput["NftIssuerDesc"] = "nft_issuer_DESC";
    ResourceOrderByInput["NftMediaAsc"] = "nft_media_ASC";
    ResourceOrderByInput["NftMediaDesc"] = "nft_media_DESC";
    ResourceOrderByInput["NftMetadataAsc"] = "nft_metadata_ASC";
    ResourceOrderByInput["NftMetadataDesc"] = "nft_metadata_DESC";
    ResourceOrderByInput["NftNameAsc"] = "nft_name_ASC";
    ResourceOrderByInput["NftNameDesc"] = "nft_name_DESC";
    ResourceOrderByInput["NftPendingAsc"] = "nft_pending_ASC";
    ResourceOrderByInput["NftPendingDesc"] = "nft_pending_DESC";
    ResourceOrderByInput["NftPriceAsc"] = "nft_price_ASC";
    ResourceOrderByInput["NftPriceDesc"] = "nft_price_DESC";
    ResourceOrderByInput["NftRecipientAsc"] = "nft_recipient_ASC";
    ResourceOrderByInput["NftRecipientDesc"] = "nft_recipient_DESC";
    ResourceOrderByInput["NftRoyaltyAsc"] = "nft_royalty_ASC";
    ResourceOrderByInput["NftRoyaltyDesc"] = "nft_royalty_DESC";
    ResourceOrderByInput["NftSnAsc"] = "nft_sn_ASC";
    ResourceOrderByInput["NftSnDesc"] = "nft_sn_DESC";
    ResourceOrderByInput["NftTransferableAsc"] = "nft_transferable_ASC";
    ResourceOrderByInput["NftTransferableDesc"] = "nft_transferable_DESC";
    ResourceOrderByInput["NftUpdatedAtAsc"] = "nft_updatedAt_ASC";
    ResourceOrderByInput["NftUpdatedAtDesc"] = "nft_updatedAt_DESC";
    ResourceOrderByInput["NftVersionAsc"] = "nft_version_ASC";
    ResourceOrderByInput["NftVersionDesc"] = "nft_version_DESC";
    ResourceOrderByInput["PendingAsc"] = "pending_ASC";
    ResourceOrderByInput["PendingDesc"] = "pending_DESC";
    ResourceOrderByInput["PriorityAsc"] = "priority_ASC";
    ResourceOrderByInput["PriorityDesc"] = "priority_DESC";
    ResourceOrderByInput["SlotAsc"] = "slot_ASC";
    ResourceOrderByInput["SlotDesc"] = "slot_DESC";
    ResourceOrderByInput["SrcAsc"] = "src_ASC";
    ResourceOrderByInput["SrcDesc"] = "src_DESC";
    ResourceOrderByInput["ThumbAsc"] = "thumb_ASC";
    ResourceOrderByInput["ThumbDesc"] = "thumb_DESC";
})(ResourceOrderByInput || (ResourceOrderByInput = {}));
export var SeriesOrderByInput;
(function (SeriesOrderByInput) {
    SeriesOrderByInput["AveragePriceAsc"] = "averagePrice_ASC";
    SeriesOrderByInput["AveragePriceDesc"] = "averagePrice_DESC";
    SeriesOrderByInput["BuysAsc"] = "buys_ASC";
    SeriesOrderByInput["BuysDesc"] = "buys_DESC";
    SeriesOrderByInput["EmoteCountAsc"] = "emoteCount_ASC";
    SeriesOrderByInput["EmoteCountDesc"] = "emoteCount_DESC";
    SeriesOrderByInput["FloorPriceAsc"] = "floorPrice_ASC";
    SeriesOrderByInput["FloorPriceDesc"] = "floorPrice_DESC";
    SeriesOrderByInput["HighestSaleAsc"] = "highestSale_ASC";
    SeriesOrderByInput["HighestSaleDesc"] = "highestSale_DESC";
    SeriesOrderByInput["IdAsc"] = "id_ASC";
    SeriesOrderByInput["IdDesc"] = "id_DESC";
    SeriesOrderByInput["ImageAsc"] = "image_ASC";
    SeriesOrderByInput["ImageDesc"] = "image_DESC";
    SeriesOrderByInput["IssuerAsc"] = "issuer_ASC";
    SeriesOrderByInput["IssuerDesc"] = "issuer_DESC";
    SeriesOrderByInput["MetadataAsc"] = "metadata_ASC";
    SeriesOrderByInput["MetadataDesc"] = "metadata_DESC";
    SeriesOrderByInput["NameAsc"] = "name_ASC";
    SeriesOrderByInput["NameDesc"] = "name_DESC";
    SeriesOrderByInput["SoldAsc"] = "sold_ASC";
    SeriesOrderByInput["SoldDesc"] = "sold_DESC";
    SeriesOrderByInput["TotalAsc"] = "total_ASC";
    SeriesOrderByInput["TotalDesc"] = "total_DESC";
    SeriesOrderByInput["UniqueCollectorsAsc"] = "uniqueCollectors_ASC";
    SeriesOrderByInput["UniqueCollectorsDesc"] = "uniqueCollectors_DESC";
    SeriesOrderByInput["UniqueAsc"] = "unique_ASC";
    SeriesOrderByInput["UniqueDesc"] = "unique_DESC";
    SeriesOrderByInput["VolumeAsc"] = "volume_ASC";
    SeriesOrderByInput["VolumeDesc"] = "volume_DESC";
})(SeriesOrderByInput || (SeriesOrderByInput = {}));
export var SpotlightOrderByInput;
(function (SpotlightOrderByInput) {
    SpotlightOrderByInput["AverageAsc"] = "average_ASC";
    SpotlightOrderByInput["AverageDesc"] = "average_DESC";
    SpotlightOrderByInput["CollectionsAsc"] = "collections_ASC";
    SpotlightOrderByInput["CollectionsDesc"] = "collections_DESC";
    SpotlightOrderByInput["IdAsc"] = "id_ASC";
    SpotlightOrderByInput["IdDesc"] = "id_DESC";
    SpotlightOrderByInput["SoldAsc"] = "sold_ASC";
    SpotlightOrderByInput["SoldDesc"] = "sold_DESC";
    SpotlightOrderByInput["TotalAsc"] = "total_ASC";
    SpotlightOrderByInput["TotalDesc"] = "total_DESC";
    SpotlightOrderByInput["UniqueCollectorsAsc"] = "uniqueCollectors_ASC";
    SpotlightOrderByInput["UniqueCollectorsDesc"] = "uniqueCollectors_DESC";
    SpotlightOrderByInput["UniqueAsc"] = "unique_ASC";
    SpotlightOrderByInput["UniqueDesc"] = "unique_DESC";
    SpotlightOrderByInput["VolumeAsc"] = "volume_ASC";
    SpotlightOrderByInput["VolumeDesc"] = "volume_DESC";
})(SpotlightOrderByInput || (SpotlightOrderByInput = {}));
export const NftListWithSearchDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'nftListWithSearch' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NFTEntityOrderByInput' } },
                        },
                    },
                    defaultValue: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'blockNumber_DESC' }] },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NFTEntityWhereInput' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'nfts' },
                        name: { kind: 'Name', value: 'nftEntities' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'burned_eq' },
                                            value: { kind: 'BooleanValue', value: false },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'metadata_not_eq' },
                                            value: { kind: 'StringValue', value: '', block: false },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'AND' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'sn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currentOwner' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'collection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'meta' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'trait' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resources' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'thumb' } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=graphql.js.map